// src/csv.js
//
// Minimal CSV parser for Google Sheets "Publish to web" output.
// Handles quoted fields, embedded commas, and escaped quotes ("").
// Returns an array of plain objects keyed by the header row.
//
// Used by screens that read low-sensitivity, info-only data from a published
// sheet URL instead of the SheetDB API — saves API quota when staleness is OK.

export function parseCSV(text) {
  const rows = [];
  let row = [];
  let field = '';
  let inQuotes = false;
  let i = 0;

  while (i < text.length) {
    const c = text[i];

    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i += 2;
          continue;
        }
        inQuotes = false;
        i++;
        continue;
      }
      field += c;
      i++;
      continue;
    }

    if (c === '"') {
      inQuotes = true;
      i++;
      continue;
    }
    if (c === ',') {
      row.push(field);
      field = '';
      i++;
      continue;
    }
    if (c === '\r') { i++; continue; }
    if (c === '\n') {
      row.push(field);
      rows.push(row);
      row = [];
      field = '';
      i++;
      continue;
    }

    field += c;
    i++;
  }

  // Flush trailing field / row
  if (field.length > 0 || row.length > 0) {
    row.push(field);
    rows.push(row);
  }

  return rows;
}

// Convert a parsed CSV (array of arrays) into an array of objects keyed by header.
export function csvToObjects(text) {
  const rows = parseCSV(text);
  if (rows.length === 0) return [];
  const headers = rows.shift().map((h) => (h || '').trim());

  return rows
    .filter((r) => r.some((v) => (v || '').trim() !== ''))
    .map((r) => {
      const obj = {};
      headers.forEach((h, idx) => {
        obj[h] = (r[idx] || '').trim();
      });
      return obj;
    });
}
